import React from "react"
import PropTypes from "prop-types"

class ClientIndex extends React.Component {
  render () {

    let clients = this.props.clients.map(client => {
      return (
        <tr key={client.id}>
          <td className="client_id">{client.id}</td>
          <td className="client_name">
            <a href={"/clients/" + client.id}>{client.name}</a>
          </td>
        </tr>
      )
    })

    return (
      <React.Fragment>
        <div className="col-md-12 col-sm-12 col-xs-12">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Κωδικός</th>
                  <th>Όνομα</th>
                </tr>
              </thead>
              <tbody id="clients-tbody">
                {clients}
              </tbody>
            </table>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ClientIndex
